// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__mTCjh","range":"MonthRangeSwitch_range__wYWTr","disabled":"MonthRangeSwitch_disabled__B-dPL"};